<div class="loaderBody">
  <ng-lottie [options]="options"></ng-lottie>
</div>
